import React from 'react';

import BadgeNoti from '../../badge/BadgeNoti';

type Props = {
  id?: string;
  className?: string;
  text: React.ReactNode;
  required?: boolean;
  tooltip?: React.ReactNode;
};

export default function Label({
  id,
  className,
  text,
  required,
  tooltip,
}: Props) {
  return (
    <div
      id={id}
      className={`flex items-center gap-1.5 ${className ?? ''}`}
    >
      <p className="break-all text-base font-medium leading-[140%] tracking-[-0.32px] text-apps-coreGrayBlack">
        {text}
      </p>
      {required && (
        <div className="flex flex-shrink-0">
          <BadgeNoti type="dot" color="primary" />
        </div>
      )}
      {tooltip && <div className="flex flex-shrink-0">{tooltip}</div>}
    </div>
  );
}
